import { View } from "react-native";
import { Text } from "react-native-paper";
import { Feather } from "@expo/vector-icons";
import { colors } from "../../theme";

type NotFoundProps = {
  title: string;
  message: string;
  icon?: keyof typeof Feather.glyphMap;
  iconColor?: string;
  iconSize?: number;
  insideModal?: boolean;
};

const DEFAULT_CLASSNAME = "bg-sky-white items-center justify-center pb-44 sm:pt-44";

const NotFound = ({ title, message, icon, iconColor = colors.sky.dark, iconSize = 66, insideModal }: NotFoundProps) => {
  const className = insideModal ? `${DEFAULT_CLASSNAME} py-32` : DEFAULT_CLASSNAME;

  return (
    <View className={className}>
      {icon && <Feather name={icon} size={iconSize} color={iconColor} testID="not-found-icon" />}
      <Text className="text-large-normal font-700 text-ink-light mt-4 px-10 text-center">{title}</Text>
      <Text className="text-regular-tight font-400 text-ink-light mt-2 px-10 text-center">{message}</Text>
    </View>
  );
};

export default NotFound;
